import { render, staticRenderFns } from "./BatchHistory.vue?vue&type=template&id=01fcb76c&scoped=true&"
import script from "./BatchHistory.vue?vue&type=script&lang=js&"
export * from "./BatchHistory.vue?vue&type=script&lang=js&"
import style0 from "./BatchHistory.vue?vue&type=style&index=0&id=01fcb76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fcb76c",
  null
  
)

export default component.exports